<button type="button" class="transparent-btn" (click)="openModal()">
  <ng-content select="[trigger]" />
</button>

<app-action-modal
  #actionModal
  size="md"
  customModalClass="cancel-policy-modal"
  submitButtonClass="lty-btn-primary"
  [disabled]="submitted"
  [submitDisabled]="submitDisabled"
  (submitted)="confirm()"
  (closed)="onClosed()"
>
  <ng-container mainTitle>
    <span class="cancel-policy-title" i18n>Résilier cette police</span>
  </ng-container>

  <ng-container subtitle>
    <span class="cancel-policy-subtitle" i18n>
      Cette police ne pourra passer en « Résiliée » qu'une fois la police de
      remplacement active.
    </span>
  </ng-container>

  <div body class="lty-form mt-32 mb-32">
    <div class="form-group mb-16">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="cancel-policy-no-replacement"
          [formControl]="noReplacement"
        />
        <label class="form-check-label" for="cancel-policy-no-replacement" i18n>
          Ne pas choisir d'affaire de remplacement
        </label>
      </div>
    </div>

    @if (modalOpen && !noReplacement.value) {
      <app-flow-select
        label="Affaire de remplacement"
        i18n-label
        [control]="replacement"
        [familyMemberId]="flow?.memberId ?? ''"
        [displayId]="flow?.displayId ?? ''"
        [excludeFlowId]="flow?.id ?? ''"
        [insuranceType]="flow?.insuranceType ?? null"
        purpose="REPLACEMENT"
        [required]="true"
        [withCreatedOn]="true"
      />
    }
  </div>

  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
